import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import {LoadingComponent} from '../../utils/ui'
import {executeGetXSD} from '../../simbix/executer'
import { XSDActions } from '../../redux';
import {LOCALSTORAGE} from '../../const/C'
import {getLastSectionPath} from '../../utils/emdUtil'

const xml = '<hello>Загрузка XSD</hello>'

const makeXSDContent = selected => {
  console.log("popUpXSD.js makeXSDContent", selected);
  let content = "<?xml version=\"1.0\" encoding=\"UTF-8\" ?>"+
    "<xs:schema xmlns:xs=\"http://www.w3.org/2001/XMLSchema\">"+
    "<xs:element name=\""+getLastSectionPath(selected.item.iri)+"\">"+
"<xs:annotation>"+
   "<xs:documentation>"+selected.name+"</xs:documentation>"+
"</xs:annotation>"+
      "</xs:element>"+
    "</xs:schema>";
  return content;
}
/**
 * Формирование XSD файла по содержимому ЕМД
 */
class XSDDiagramm extends React.Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            url: undefined,
            loading: false, 			//Флаг загрузки
        }
    }

    componentDidMount() {
        this.loadXSD()
    }

    componentWillReceiveProps(newProps) {
        this.setState({url: null});
    }

    loadXSD(){
        const selected = this.props.selected;
        this.props.onMakeXSDContent(xml).then(response =>{
          const content = makeXSDContent(selected); //: response
          localStorage.setItem(LOCALSTORAGE.XSD, content);
          this.setState({url: this.props.selected.item.iri, content});
        });
        // executeGetXSD({name: selected.name, iri: selected.item.iri}).then(response =>{
        //     console.log("executeGetXSD"); console.log(response);
        //     this.setState({url: response.data.url});
        // });
    }

  render() {
    console.log(this); 
    const selected = this.props.selected;
    const {url, content} = this.state;
    if (url==null) this.loadXSD();
    return (
      <div>
                {!url&& <span><LoadingComponent /><p>Дождитесь ссылку на скачивания XSD файла.</p></span>}                
                {url && (
                  <Link to={{pathname:"/xsd/"+encodeURIComponent(url), state: [{content}]}} target="_blank">Cсылка на содержимое XSD.</Link>
                )} 
            </div>
    );
  }
};

//Представление информации о диаграмме UML элемента EMD
export default connect(
    null,
    dispatch => ({
      onMakeXSDContent(content){
        return dispatch(XSDActions.setXSDContent(content));
      },      
    })
)(XSDDiagramm);
